module.exports = __webpack_public_path__ + "images/marketing/logo-cloops.png";